var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { class: ["table-cell-success", _setup.status.tag] },
    [_c(_setup.Icon, { attrs: { size: "1rem", icon: _setup.status.icon } })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }